import * as THREE from 'three'
import Project from './Project'
import TweenLite from 'gsap/TweenLite'

import projectsHoppinProfileSlideASources from '../../../models/projects/zqProfile/IMG_20230629_163710.jpg'
import projectsHoppinProfileSlideBSources from '../../../models/projects/zqProfile/IMG_20230629_163910.jpg'
import projectsHoppinProfileSlideCSources from '../../../models/projects/zqProfile/5nA5oo5XzT.png'
import projectsHoppinProfileSlideDSources from '../../../models/projects/zqProfile/rz.jpg'

import projectsHoppinBlogSlideASources from '../../../models/projects/hoppinBlog/slideA.jpg'
import projectsHoppinBlogSlideBSources from '../../../models/projects/hoppinBlog/slideB.jpg'
import projectsHoppinBlogSlideCSources from '../../../models/projects/hoppinBlog/slideC.jpg'
import projectsHoppinBlogSlideDSources from '../../../models/projects/hoppinBlog/slideD.jpg'

import projectsHoppinVideoSlideASources from '../../../models/projects/hoppinVideo/ChromeCore_iI7MXkZm7x.png'
import projectsHoppinVideoSlideBSources from '../../../models/projects/hoppinVideo/ChromeCore_kJcPaQm235.png'
import projectsHoppinVideoSlideCSources from '../../../models/projects/hoppinVideo/ChromeCore_fUCZrWuUdp.png'

import projectsHoppinChatSlideASources from '../../../models/projects/hoppinChat/chrome_AZjGhRuryk.png'
import projectsHoppinChatSlideBSources from '../../../models/projects/hoppinChat/ChromeCore_BcyrxqpdXy.png'

import projectsHoppinZuiSlideASources from '../../../models/projects/hoppinZui/ChromeCore_Nj3AqJwoAJ.png'
import projectsHoppinZuiSlideBSources from '../../../models/projects/hoppinZui/ChromeCore_S72EBrgbE1.png'
import projectsHoppinZuiSlideCSources from '../../../models/projects/hoppinZui/ChromeCore_VgjH0O6qwA.png'

import projectsHoppinManagerSlideASources from '../../../models/projects/hoppinManager/ChromeCore_VfC6vdw4tu.png'
import projectsHoppinManagerSlideBSources from '../../../models/projects/hoppinManager/ChromeCore_mx1JPUSY9K.png'
import projectsHoppinManagerSlideCSources from '../../../models/projects/hoppinManager/ChromeCore_mNBgvnHjRS.png'

import projectsYqcrSlideASources from '../../../models/projects/yqcr/ChromeCore_U9huSHwgtX.jpg'
import projectsYqcrSlideBSources from '../../../models/projects/yqcr/ChromeCore_P0Q7BCCJ4b.png'
import projectsYqcrSlideCSources from '../../../models/projects/yqcr/ChromeCore_5EfLuytNtI.png'

import projectsValorantSlideASources from '../../../models/projects/Valorant/VALORANT-Win64-Shipping_NZwTgU9fF1.jpg'
import projectsValorantSlideBSources from '../../../models/projects/Valorant/VALORANT-Win64-Shipping_C8kZaZb4du.jpg'
import projectsValorantSlideCSources from '../../../models/projects/Valorant/VALORANT-Win64-Shipping_alNCoutoRx.jpg'

import projectsHoppinOtherSlideASources from '../../../models/projects/hoppinOther/ChromeCore_MQRTkHEklx.png'
import projectsHoppinOtherSlideBSources from '../../../models/projects/hoppinOther/ChromeCore_IWHfen2fle.png'
import projectsHoppinOtherSlideCSources from '../../../models/projects/hoppinOther/ChromeCore_uLoJaVKud9.png'
import projectsHoppinOtherSlideDSources from '../../../models/projects/hoppinOther/ChromeCore_ZA4W1HXeOM.png'
/**
 * 设置项目
 */
export default class ProjectsSection
{
    constructor(_options)
    {
        this.time = _options.time
        this.resources = _options.resources
        this.camera = _options.camera
        this.passes = _options.passes
        this.objects = _options.objects
        this.areas = _options.areas
        this.zones = _options.zones
        this.tiles = _options.tiles
        this.debug = _options.debug
        this.x = _options.x
        this.y = _options.y

        if(this.debug)
        {
            this.debugFolder = this.debug.addFolder('projects')
            this.debugFolder.open()
        }

        this.items = []

        this.interDistance = 24
        this.positionRandomess = 5
        this.projectHalfWidth = 9

        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false
        this.container.updateMatrix()

        this.setGeometries()
        this.setMeshes()
        this.setList()
        this.setZone()

        for(const _options of this.list)
        {
            this.add(_options)
        }
    }

    setGeometries()
    {
        this.geometries = {}
        this.geometries.floor = new THREE.PlaneBufferGeometry(16, 8)
    }

    setMeshes()
    {
        this.meshes = {}

        // this.meshes.boardStructure = this.objects.getConvertedMesh(this.resources.items.projectsBoardStructure.scene.children, { floorShadowTexture: this.resources.items.projectsBoardStructureFloorShadowTexture })
        this.resources.items.areaOpenTexture.magFilter = THREE.NearestFilter
        this.resources.items.areaOpenTexture.minFilter = THREE.LinearFilter
        this.meshes.boardPlane = this.resources.items.projectsBoardPlane.scene.children[0]
        this.meshes.areaLabel = new THREE.Mesh(new THREE.PlaneBufferGeometry(2, 0.5), new THREE.MeshBasicMaterial({ transparent: true, depthWrite: false, color: 0xffffff, alphaMap: this.resources.items.areaOpenTexture }))
        this.meshes.areaLabel.matrixAutoUpdate = false
    }

    setList()
    {
        this.list = [
            {
                name: '自我介绍',
                imageSources:
                [
                   projectsHoppinProfileSlideASources,
                   projectsHoppinProfileSlideBSources,
                   projectsHoppinProfileSlideCSources,
                   projectsHoppinProfileSlideDSources
                ],
                 //竖的照片，先不处理
                floorTexture: this.resources.items.projectsZQProfileFloorTexture,
                link:
                {
                    href: 'https://hoppinzq.com/zq/doc.html',
                    x: 0,
                    y: - 6.5,
                    halfExtents:
                    {
                        x: 8,
                        y: 2
                    }
                },
                distinctions:
                [
                    { type: 'Java', x: -1.5, y: 2 },
                    { type: 'Activiti', x: 0.4, y: 2 },
                    { type: 'Redis', x: 2.5, y: 2 },
                    { type: 'Kafka', x: 4.4, y: 2 },
                    { type: 'JQuery', x: 6, y: 2 },
                    { type: 'Spring', x: -1.5, y: 1 },
                    { type: 'Mysql', x: 0.7, y: 1 },
                    { type: 'Zookeeper', x: 2.7, y: 1 },
                    { type: 'Elasticsearch', x: 0, y: 2.6 },
                    { type: 'Dubbo', x: 5.9, y: 1 },
                    { type: 'Eureka', x: 4.9, y: 1.6 },
                    { type: 'Lucene', x: -1.5, y: 0 },
                    { type: 'Nacos', x: -1.2, y: 1 },
                    { type: 'Oracle', x: 3, y: 1.8 },
                    { type: 'C', x: 0.7, y: 0 },
                    { type: 'ChatGPT', x: 3.8, y: 0 },
                    { type: 'Python', x: 6.6, y: 0 },
                    { type: 'Docker', x: -1.5, y: -0.95 },
                    { type: 'Mybatis', x: 0.9, y: -0.95 },
                    { type: 'RocketMQ', x: 3.3, y: -0.95 },
                    { type: 'VUE', x: 6.5, y: -0.95 },
                ]
            },
            // 其他
            {
                name: 'hoppin.cn 博客网站',
                imageSources:
                [
                   projectsHoppinBlogSlideASources,
                   projectsHoppinBlogSlideBSources,
                   projectsHoppinBlogSlideCSources,
                   projectsHoppinBlogSlideDSources
                ],
                floorTexture: this.resources.items.projectsHoppinBlogFloorTexture,
                link:
                {
                    href: 'http://hoppin.cn/',
                    x: - 4.8,
                    y: - 3,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                distinctions:
                [
                    { type: 'Java', x: 1.15, y: 5.15 },
                    { type: 'Redis', x: 3.1, y: 5 },
                    { type: 'Lucene', x: -1, y: 5 },
                    { type: 'Mysql', x: -1, y: 2.5 },
                    { type: 'Spring', x: 2, y: 4 },
                    { type: 'Mybatis', x: -1.2, y: 3.95 }
                ]
            },{
                name: 'hoppinzq.com 视频与直播网站',
                imageSources:
                [
                   projectsHoppinVideoSlideASources,
                   projectsHoppinVideoSlideBSources,
                   projectsHoppinVideoSlideCSources
                ],
                floorTexture: this.resources.items.projectsHoppinVideoFloorTexture,
                link:
                {
                    href: 'https://hoppinzq.com/video/index.html',
                    x: - 4.8,
                    y: - 3,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                distinctions:
                [
                    { type: 'Java', x: 0.95, y: 5.15 },
                    { type: 'Redis', x: 2.5, y: 5 },
                    { type: 'Lucene', x: -2, y: 5 },
                    { type: 'Mysql', x: -2, y: 2.5 },
                    { type: 'Spring', x: 1.5, y: 4 },
                    { type: 'Mybatis', x: -1.2, y: 3.95 },
                    { type: 'ChatGPT', x: 1.5, y: 2.5 }
                ]
            },{
                name: 'hoppinzq.com 服务管理网站',
                x:95,
                y:-15,
                imageSources:
                [
                   projectsHoppinManagerSlideASources,
                   projectsHoppinManagerSlideBSources,
                   projectsHoppinManagerSlideCSources
                ],
                floorTexture: this.resources.items.projectsHoppinManagerFloorTexture,
                link:
                {
                    href: 'https://hoppinzq.com/manager/index.html',
                    x: - 4.8,
                    y: - 3,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                distinctions:
                [
                    { type: 'Java', x: 2.95, y: 5.15 },
                    { type: 'Redis', x: 4.5, y: 5 },
                    { type: 'ChatGPT', x: 0, y: 5 },
                    { type: 'Mysql', x: 0, y: 2.5 },
                    { type: 'Spring', x: 3.5, y: 4 },
                    { type: 'Mybatis', x: 0.2, y: 3.95 }
                ]
            },{
                name: 'hoppinzq.com ChatGPT网站',
                x:120,
                y:-25,
                imageSources:
                [
                   projectsHoppinChatSlideASources,
                   projectsHoppinChatSlideBSources
                ],
                floorTexture: this.resources.items.projectsHoppinChatFloorTexture,
                link:
                {
                    href: 'http://hoppinzq.com/chat/index.html',
                    x: - 4.8,
                    y: - 3,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                distinctions:
                [
                    { type: 'Java', x: 2.95, y: 5.15 },
                    { type: 'Redis', x: 4.5, y: 5 },
                    { type: 'ChatGPT', x: 0, y: 5 },
                    { type: 'Mysql', x: 0, y: 2.5 },
                    { type: 'Spring', x: 3.5, y: 4 },
                    { type: 'Mybatis', x: 0.2, y: 3.95 }
                ]
            },{
                name: 'hoppinzq.com 其他开源',
                imageSources:
                [
                   projectsHoppinOtherSlideASources,
                   projectsHoppinOtherSlideBSources,
                   projectsHoppinOtherSlideCSources,
                   projectsHoppinOtherSlideDSources
                ],
                floorTexture: this.resources.items.projectsHoppinOtherFloorTexture,
                link:
                {
                    href: 'https://gitee.com/hoppin',
                    x: - 4.8,
                    y: - 3,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                distinctions:
                [
                    { type: 'Java', x: 2.95, y: 5.15 }
                ]
            },{
                name: '肉鸽游戏元气超人',
                x:170,
                y:-45,
                imageSources:
                [
                   projectsYqcrSlideASources,
                   projectsYqcrSlideBSources,
                   projectsYqcrSlideCSources
                ],
                floorTexture: this.resources.items.projectsYqcrFloorTexture,
                link:
                {
                    href: 'http://hoppin.cn/web/unity/yqcr/gameIndex.html',
                    x: - 4.8,
                    y: - 3,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                distinctions:
                [

                ]
            },{
                name: '瓦洛兰特',
                x:170,
                y:-65,
                imageSources:
                [
                   projectsValorantSlideASources,
                   projectsValorantSlideBSources,
                   projectsValorantSlideCSources
                ],
                floorTexture: this.resources.items.projectsValorantFloorTexture,
                link:
                {
                    href: 'https://val.qq.com/main.html',
                    x: - 4.8,
                    y: - 3,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                distinctions:
                [

                ]
            }
        ]
    }

    setZone()
    {
        const totalWidth = this.list.length * (this.interDistance / 2)

        const zone = this.zones.add({
            position: { x: this.x + totalWidth - this.projectHalfWidth - 6, y: this.y },
            halfExtents: { x: totalWidth, y: 12 },
            data: { cameraAngle: 'projects' }
        })

        zone.on('in', (_data) =>
        {
            this.camera.angle.set(_data.cameraAngle)
            TweenLite.to(this.passes.horizontalBlurPass.material.uniforms.uStrength.value, 2, { x: 0 })
            TweenLite.to(this.passes.verticalBlurPass.material.uniforms.uStrength.value, 2, { y: 0 })
        })

        zone.on('out', () =>
        {
            this.camera.angle.set('default')
            TweenLite.to(this.passes.horizontalBlurPass.material.uniforms.uStrength.value, 2, { x: this.passes.horizontalBlurPass.strength })
            TweenLite.to(this.passes.verticalBlurPass.material.uniforms.uStrength.value, 2, { y: this.passes.verticalBlurPass.strength })
        })
    }

    add(_options)
    {
        const x = this.x + this.items.length * this.interDistance
        let y = this.y
        if(this.items.length > 0)
        {
            y += (Math.random() - 0.5) * this.positionRandomess
        }

        // 项目配置
        const project = new Project({
            time: this.time,
            resources: this.resources,
            objects: this.objects,
            areas: this.areas,
            geometries: this.geometries,
            meshes: this.meshes,
            debug: this.debugFolder,
            x: x,
            y: y,
            ..._options
        })

        this.container.add(project.container)

        if(this.items.length >= 1)
        {
            const previousProject = this.items[this.items.length - 1]
            const start = new THREE.Vector2(previousProject.x + this.projectHalfWidth, previousProject.y)
            const end = new THREE.Vector2(project.x - this.projectHalfWidth, project.y)
            const delta = end.clone().sub(start)
            this.tiles.add({
                start: start,
                delta: delta
            })
        }

        this.items.push(project)
    }
}
